export const NopStressTestPermissions = {
  default: 'User.RiskMonitoring.NopStressTest',
  reverseStopOut: 'User.RiskMonitoring.NopStressTest.ReverseStopOut',
  byCcy: 'User.RiskMonitoring.NopStressTest.ByCcy',
  uniqueId: 'User.RiskMonitoring.NopStressTest.UniqueId',
} as const;
